import { render, staticRenderFns } from "./ProviderBills.vue?vue&type=template&id=46eebd87&"
import script from "./ProviderBills.vue?vue&type=script&lang=js&"
export * from "./ProviderBills.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports